import { selectors } from './carousel';
window.refreshSections = function (sectionsToRefresh) {
  const sections = sectionsToRefresh.map(section => section.id);
  fetch(`?sections=${sections}`, {}).then(response => {
    return response.text();
  }).then(state => {
    const parsedState = JSON.parse(state);
    this.renderContents({
      sectionsToRefresh: sectionsToRefresh,
      sections: parsedState
    }, false);
    // only load carousel when .swiper__parent is present
    const carouselNodes = document.querySelectorAll(selectors.parent);
    if (carouselNodes.length > 0) {
      import(/* webpackChunkName: "carousel-import" */'./carousel').then(module => module.carouselInit());
    }
  }).catch(error => {
    console.error(error);
  });
};
window.renderContents = function (parsedState) {
  parsedState.sectionsToRefresh.forEach(section => {
    if (section.dynamic) {
      document.getElementById('shopify-section-' + section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    } else {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }
    if (section.id === 'cart-drawer') {
      document.getElementById(section.id).setupCloseButton();
    }
  });
};
window.getSectionInnerHTML = function (html) {
  let selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.shopify-section';
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
};